import React from "react";
import { CheckCircle, ArrowRight } from "lucide-react";

const SIEMComparisonSection = () => {
  const differentiators = [
    {
      title: "Agentic AI for Contextual Decisions",
      description: "Unlike SIEMs that rely on static rules, Spharaka leverages Agentic AI to continuously learn, adapt, and correlate signals across endpoints, networks, cloud, and identity systems."
    },
    {
      title: "From Detection to Autonomous Response",
      description: "SIEMs stop at alerting. Spharaka goes further and detects, validates, and remediates threats autonomously, reducing MTTR from hours to minutes."
    },
    {
      title: "Noise Elimination",
      description: "Traditional SIEMs overwhelm SOC teams with false positives. Spharaka's intelligent correlation and ISHWAR oversight deliver only actionable insights to analysts."
    },
    {
      title: "Built for Scale & Cloud Native Environments",
      description: "SIEM architectures struggle with massive data volumes. Spharaka is cloud native, scalable, and optimized for real time security telemetry without budget constraints."
    },
    {
      title: "Compliance & Explainability",
      description: "With ISHWAR (Intelligent Surveillance and Holistic Watchdog for Agentic Response), every AI driven decision is explainable, auditable, and compliant with enterprise standards."
    }
  ];

  return (
    <section className="py-16 bg-gray-50" id="siem-comparison">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Can Spharaka XDR Replace Traditional <span className="text-[#8932c8]">SIEM</span>?
            </h2>
            <p className="text-2xl font-semibold text-[#8932c8] mb-6">
              Yes — and go far beyond.
            </p>
            <div className="max-w-3xl mx-auto">
              <p className="text-lg text-gray-700 mb-6">
                Traditional SIEM solutions were designed for a different era: they collect logs, correlate events, and raise alerts. While effective in the past, they are limited by high noise, manual rule management, and reactive security posture.
              </p>
              <p className="text-xl font-semibold text-gray-900 mb-8">
                Spharaka XDR is not just a replacement, but an evolution.
              </p>
            </div>
          </div>

          {/* Key Differentiators */}
          <div className="space-y-8 mb-12">
            {differentiators.map((item, index) => (
              <div key={index} className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <CheckCircle className="h-6 w-6 text-[#8932c8] mt-1" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-3 text-gray-900">
                      {item.title}
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Conclusion */}
          <div className="bg-[#8932c8] rounded-lg p-8 text-white text-center">
            <p className="text-xl font-semibold leading-relaxed">
              Spharaka XDR doesn't just replace SIEM. It redefines it from a log aggregator into a truly autonomous cyber defense platform.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SIEMComparisonSection;